import { History } from "lucide-react";

const quando = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : `${d.toLocaleDateString("pt-BR")} às ${d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}`;
};

/** "Reaberto" enquanto o pedido está aberto de novo; "Editado" depois de
 *  fechado outra vez. Nada para pedido que nunca foi reaberto. */
export default function SeloReaberto({ pedido, className = "" }) {
  if (!pedido?.reaberto_em) return null;
  const fechado = pedido.status === "concluido" || pedido.status === "cancelado";
  const titulo = `${fechado ? "Editado · " : ""}Reaberto por ${pedido.reaberto_por || "—"} em ${quando(pedido.reaberto_em)}`;
  return (
    <span title={titulo} data-e2e={fechado ? "selo-editado" : "selo-reaberto"}
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] font-semibold ${fechado
        ? "bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-300"
        : "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300"} ${className}`}>
      <History className="w-2.5 h-2.5" />{fechado ? "Editado" : "Reaberto"}
    </span>
  );
}

export { quando };
